module.exports = __webpack_public_path__ + "img/GMOS6-3.fb101e6d.png";